export const SHOW_KEYBOARD = 'SHOW_KEYBOARD';
export const GENERATE_DEVICE_ID = 'GENERATE_DEVICE_ID';
